import { fitClamped } from "@thi.ng/math";
import { IRect } from "../../../../../../api";

export const posToDuration_s = (pos: number, bodyRect: IRect, maxTimeS: number) =>
  fitClamped(pos, bodyRect.x, bodyRect.x + bodyRect.w, 0, maxTimeS);
